import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rentControlLabel',
  standalone: true,
})
export class RentControlLabelPipe implements PipeTransform {
  transform(value: 'rso' | 'ab1482' | 'none' | 'unknown' | null | undefined): string {
    switch (value) {
      case 'rso':
        return 'RSO';
      case 'ab1482':
        return 'AB 1482';
      case 'none':
        return 'None';
      default:
        return '—';
    }
  }
}
